export default __webpack_public_path__ + "media/images/email-28d79d50d959c81d1fcde88a5552729e.svg";